
import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ConceptPage = lazy(() => import('../pages/concept/page'));
const MenuPage = lazy(() => import('../pages/menu/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const VoicePage = lazy(() => import('../pages/voice/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const AccessPage = lazy(() => import('../pages/access/page'));
const InstagramPage = lazy(() => import('../pages/instagram/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/concept',
    element: <ConceptPage />,
  },
  {
    path: '/menu',
    element: <MenuPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/voice',
    element: <VoicePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/access',
    element: <AccessPage />,
  },
  {
    path: '/instagram',
    element: <InstagramPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
